<template>
  <div class="sidebar-container" :class="{'is-active':isCollapse}" v-loading="loadingMenu"
       element-loading-background="rgba(0, 0, 0, 0.5)">
    <div class="search-box flex center">
      <el-input v-show="!isCollapse" v-model="search" class="input-v2 gray" :placeholder="$t('menu.search')" suffix-icon="el-icon-search" clearable />
    </div>
    <div class="menu-body">
      <el-menu :unique-opened="uniqueOpened"
               :default-active="nowTagValue"
               mode="vertical"
               :collapse="isCollapse"
               :default-openeds="openeds"
      >
        <sidebar-item :menuData="getMenus" :isCollapse="isCollapse" :show-icon="true"></sidebar-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import SidebarItem from './sidebarItem';
import homeMenus from '@/menus/home/home';
import wageMenus from '@/menus/wage/wage';
import hrCloudMenus from '@/menus/hrcloud/hrMenu.js';
import hrCloudSetMenus from '@/menus/hrcloud/hrSetMenu.js';
import reportMenus from '@/menus/wage/report.js';
import dataInput from '@/menus/dataInput/dataInputZL.js';
import financeService from '@/menus/finance/service'
import tesla from '@/menus/wage/tesla.js';
import policy from '@/menus/policy/policyLibrary.js';
import teslaCustomRecord from '@/menus/tesla/teslaCustomRecord.js';
import {setUrlPath, deepCopy, getAuthorizedMenu, dataToTree, matchUrl} from '@/util/util';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import {ygjMenuParamTo} from '@/api/user/login';

export default {
  name: 'sidebar',
  components: {SidebarItem},
  data() {
    return {
      loading: false,
      screenWidth: document.body.clientWidth, // 屏幕宽度
      localMenu: [],
      menusArrayFilter: [],
      search: '',
      uniqueOpened: true,
      openeds: []
    };
  },
  created() {
    this.isLocal = process.env.VUE_APP_LOCAL_DEVELOPMENT
    if (this.screenWidth <= 1400) {
      this.$store.commit('SET_COLLAPSE');
    }
    let newMenusArray = [...homeMenus, ...hrCloudMenus, ...wageMenus, ...reportMenus, ...tesla, ...financeService, ...hrCloudSetMenus, ...policy, ...teslaCustomRecord];
    const hasZLPermission = this.pms[1].some(item => item.operateCode == 'hr_wage_new_report_data_center_zl')
    if (hasZLPermission) {
      newMenusArray = [...reportMenus, ...dataInput, ...hrCloudMenus, ...wageMenus, ...tesla, ...financeService, ...hrCloudSetMenus, ...policy, ...teslaCustomRecord];
    }
    this.localMenu = newMenusArray;
    let menuData = deepCopy(newMenusArray);
    const menuSet = this.pms[1].map(item => {
      return item.operateCode;
    })
    let newMenusArrayFilter = getAuthorizedMenu(menuData, menuSet)
    this.menusArrayFilter = newMenusArrayFilter;
    //this.initWebSocket();
  },
  computed: {
    ...mapGetters(['isCollapse', 'pms', 'ygj', 'menu', 'opened', 'memberInfo', 'accessToken', 'loadingMenu']),
    nowTagValue() {
      return setUrlPath(this.$route);
    },
    getMenus() {
      let menuTotal = [...this.menusArrayFilter, ...dataToTree(JSON.parse(JSON.stringify(this.ygj)))]
      // 如果是搜索状态，则允许展开多个菜单
      this.uniqueOpened = !this.search
      if (this.search) {
        // 搜索菜单
        menuTotal = this.$clone(menuTotal)
        menuTotal = menuTotal.filter(menu => {
          if (menu.children) {
            menu.children = menu.children.filter(child => child.label.includes(this.search))
            return menu.children.length || menu.label.includes(this.search)
          }
          return menu.label.includes(this.search)
        })
        // 展开所有匹配搜索的菜单
        this.openeds = []
        menuTotal.forEach(menu => {
          this.openeds.push(menu.id)
        })
      } else if (this.openeds.length) {
        this.openeds = []
      }
      this.$store.commit('SET_MENU', menuTotal)
      return menuTotal
    },
  },
  methods: {
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    initWebSocket() {
      this.connection();
      let that = this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      // this.timer = setInterval(() => {
      //   try {
      //     that.stompClient.send("test");
      //   } catch (err) {
      //     console.log("断线了: " + err);
      //     that.connection();
      //   }
      // }, 5000);
    },
    //上线
    connection() {
      //建立连接对象
      let baseUrl = process.env.VUE_APP_BASE_URL;
      //建立连接对象
      let socket = new SockJS("/api/message/ws");
      // debugger
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);
      //将socket对象存在session里
      // sessionStorage.setItem("stompClient", this.stompClient);
      this.stompClient.debug = null
      // 定义客户端的认证信息,按需求配置
      let headers = {
        'Authorization': 'Bearer ' + this.accessToken
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(headers, () => {
        this.stompClient.subscribe('/user/' + this.memberInfo.id + '/message', (msg) => {
          // msg.body存放的是服务端发送给我们的信息
          if (this.$route.path != '/index') {
            this.$notify.info({
              title: '消息',
              message: '您有新的消息，请注意查收'
            });
          }
          this.resetSetItem('sockedMsgContent', msg.body);
        }, headers);
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log('失败')
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sidebar-container {
  width: 208px;
  overflow: hidden;
  position: relative;
  background: #FFFFFF;
  border-right: 1px solid #E8E8E8;
  transition: width .6s;

  &.is-active {
    width: 58px !important;
  }
  .search-box {
    height: 72px;
    padding: 0 16px;
  }
  .menu-body {
    .el-menu {
      border-right-width: 0;
    }
    width: 208px;
    height: calc(100vh - 180px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}

/* for Chrome */
.menu-body::-webkit-scrollbar {
  display: none;
}

#app .el-menu {
  background: #FFFFFF;
}

.el-menu--collapse {
  ::v-deep .el-submenu.is-active {
    background: rgba(255,150,1,0.06) !important;
  }
  ::v-deep .el-submenu__icon-arrow {
    display: none;
  }
}
</style>
